export const LOGIN = 'login';
export const LOGOUT = 'logout';
export const REGISTER = 'register';
export const CHECK_AUTH = 'checkAuth';
export const CREATE_PROJECT = 'createProject';
export const FETCH_PROJECT = 'fetchProject';
export const FETCH_PROJECTS = 'fetchProjects';
export const FETCH_PROJECTS_USERNAME = 'fetchProjectsFromUsername'